import { Flex, Box, AspectRatio } from "@chakra-ui/react";
import React from "react";
import Image, { type StaticImageData } from "next/legacy/image";
import { TextTitle } from "ui/text";
import { Section } from "components/section";
import { HeroCTA } from "components/hero";

type IntegrationsHeroProps = {
  title: string;
  image: StaticImageData;
};

export function IntegrationsHero({ title, image }: IntegrationsHeroProps) {
  return (
    <Section
      bgGradient="linear(120deg, #37D070 -50%, #21936D 15%, #15735D 120%)"
      color="white"
      my={0}
      mb={{ base: 0, lg: 10 }}
      py={{ base: 12, md: 16 }}
    >
      <Flex
        direction={{ base: "column", lg: "row" }}
        justifyContent="space-between"
        align={{ base: "start", lg: "center" }}
        gap={4}
      >
        <TextTitle
          theme="dark"
          size="lg"
          chip={{ text: "Integrations" }}
          title={title}
          titleAs="h1"
          actions={<HeroCTA />}
        />

        <Box display={{ base: "none", lg: "block" }} pos="relative" flex={1} w="100%" maxW="300px">
          <AspectRatio ratio={3 / 2} w="100%">
            <Image priority src={image} alt="Hero image." layout="fill" objectFit="contain" />
          </AspectRatio>
        </Box>
      </Flex>
    </Section>
  );
}
